export default "__VITE_ASSET___bRjkGiJ__"